export default {
  /**
   * @description 判断两个对象是否相等，目前只支持对象值为简单数据类型的判断
   * @param {Object} obj1 对象1
   * @param {Object} obj2 对象2
   * @returns
   */
  obj_is_equal: (obj1, obj2) => {
    const keys1 = Object.getOwnPropertyNames(obj1)
    const keys2 = Object.getOwnPropertyNames(obj2)
    if (keys1.length != keys2.length) {
      return false
    }
    for (let i = 0; i < keys1.length; i++) {
      let key = keys1[i]
      let val1 = obj1[key]
      let val2 = obj2[key]
      if (val1 !== val2) {
        return false
      }
    }
    return true
  },
  /**
   * @description 合并两个对象，优先后者
   * @description Merges two objects, giving the last one precedence
   * @param {Object} target
   * @param {Object|Array} source
   * @returns {Object}
   */
  obj_merge: (target, source) => {
    if (typeof target !== 'object') {
      target = {}
    }
    if (Array.isArray(source)) {
      return source.slice()
    }
    Object.keys(source).forEach(property => {
      const sourceProperty = source[property]
      if (typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty)
      } else {
        target[property] = sourceProperty
      }
    })
    return target
  },
}
